export function clearToken() {
    localStorage.removeItem("token");
};

export function storeToken(token) {
    localStorage.setItem("token", token);
};

export function tokenExists() {
    if (!localStorage.getItem("token")) {
        return false;
    }

    return true;
};

export function getToken() {
    if (!tokenExists()) return undefined;
    return localStorage.getItem("token");
}

export function getAuthorizationHeaderValue() {
    return `Bearer ${localStorage.getItem("token")}`;
};

export function parseJWT(token) {
    try {
        // https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
        // Note: this does not validate the signature, it just extracts the JSON payload from the token, which could have been tampered with.
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch {
        // invalid jwt token
        return {};
    }
}
